import { HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { API_BACKEND_SERVICE } from '../../constants/connection.apiservice.contant';
import { IUnique } from '../../definitions/interfaces';
import { ElementDefinitionTarget, IntegrationModel } from '../../models/integration.model';
import { ApiService } from '../../services/api.service';
import { CRUDResource } from '../crud.resource';
import { INTEGRATIONS } from '../resources';

const mockedItems = [
  {
    id: "a71ec792-da70-4053-8d45-502ec1be7ac5",
    name: 'Workroads',
    type: ElementDefinitionTarget.Workroads,
    connectionString: 'http://localhost:8069'
  }
]


@Injectable({
  providedIn: 'root'
})
export class IntegrationResourceService extends CRUDResource<IntegrationModel> {
  getHealthStatuses(arg0: string[]): Observable<Record<string, string>> {
    return of({});
  }
  public isMock = true;

  constructor(
    @Inject(API_BACKEND_SERVICE) api: ApiService) {
    super(
      api,
      '',
      INTEGRATIONS,
      (obj: IUnique) => new IntegrationModel(obj)
    );
  }

  getAll(params?: HttpParams): Observable<IntegrationModel[]> {
    if (this.isMock) {
      return of(mockedItems.map((item) => new IntegrationModel(item)));
    }

    return super.getAll(params);
  }

}
